import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonWalking, faBicycle, faCar, faCity } from '@fortawesome/free-solid-svg-icons';
import { TransportMode } from '../hooks/useCoffeeShops';

interface TransportPickerProps {
    value: TransportMode;
    onChange: (value: TransportMode) => void;
    className?: string;
}

const transportOptions: { mode: TransportMode; icon: any; label: string; distance: string }[] = [
    { mode: 'foot', icon: faPersonWalking, label: 'Walk', distance: '~2km' },
    { mode: 'bike', icon: faBicycle, label: 'Bike', distance: '~10km' },
    { mode: 'car', icon: faCar, label: 'Car', distance: '~50km' },
    { mode: 'city', icon: faCity, label: 'City', distance: 'all' }
];

const TransportPicker: React.FC<TransportPickerProps> = ({
    value,
    onChange,
    className = ''
}) => {
    return (
        <div className={`grid grid-cols-4 gap-2 ${className}`}>
            {transportOptions.map(({ mode, icon, label, distance }) => (
                <button
                    key={mode}
                    type="button"
                    onClick={() => onChange(mode)}
                    className={`
                        flex flex-col items-center justify-center
                        px-3 py-3 rounded-xl border backdrop-blur-sm
                        transition-all duration-200
                        ${value === mode
                            ? 'bg-sky/80 border-sky text-ink shadow-md scale-[1.02]'
                            : 'bg-paper/70 border-ink/15 text-ink hover:bg-paper/90 hover:shadow-sm'
                        }
                    `}
                    title={`${label} (${distance})`}
                >
                    <FontAwesomeIcon icon={icon} className="text-lg mb-1" />
                    <span className="text-xs font-semibold">{label}</span>
                    <span className={`text-[10px] ${value === mode ? 'text-ink/70' : 'text-muted-foreground'}`}>
                        {distance}
                    </span>
                </button>
            ))}
        </div>
    );
};

export default TransportPicker;
